import { createSelector } from 'reselect';

const getRoot = state => state;
const getState = createSelector(getRoot, state => state.ivsCallCenterResults);
export const getFormattedIvsVin = createSelector(getState, ivs => ivs.items ? new Map(ivs.items.map(item => [item.vin, item])) : new Map());
export const isLoadingIvsVin = createSelector(getState,  ({loading}) => loading);
